import React, { useContext, useEffect, useState } from 'react'
import MUIDataTable,{TableViewCol} from "mui-datatables";
import styled from '@emotion/styled';
import ProfileContext from '../../../context/ProfileContext';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";


const muiCache = createCache({
	"key": "mui",
	"prepend": true
});

// const data = [
//  ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","II","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","I","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2021","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//   ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","II","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","I","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2021","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//   ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","II","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","I","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2021","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//   ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","II","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","II","Undergraduate"],
//  ["Internet Programming","SWEG303", "3rd", "A", "Lab","25","3","2022","I","Undergraduate"],
//  ["Object-Oriented Programming","SWEG301","3rd", "B", "Lec","50","4","2021","II","Undergraduate"],
//  ["Fundamental of Programming","SWEG203","2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
//  ["Fundamental of Programming","SWEG203", "2nd", "A","Lab","25", "3","2022","I","Undergraduate"],
 

// ];

const options = {
  filterType: 'multiselect',
  selectableRows:'none',
  rowsPerPage:3,
  rowsPerPageOptions:[3,10,20,40],
  rowHover:false,
  // responsive:'scroll',
};
const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  height:'100%',
   '& .tss-1l6och6-MUIDataTableHeadCell-fixedHeader':{
       padding:'5px 5px 5px 10px',
  },
  '& .tss-v24t37-MUIDataTableHeadCell-fixedHeader':{
       padding:'5px 5px 5px 10px',
  },
  // '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px',
  //   textTransform:'none'
  // },
  // '& .css-1v17xvx-MuiTableCell-root':{
  //   padding:'5px',
  //   textTransform:'none'
  // },
  // '& .css-10ud224-MuiTableCell-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',

  // },
}))
export default function TeachingLoad() {
  const {changed}=useAuth();
  const api=useAxiosPrivate()
  const [data,setData]=useState([])
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`load/view/`,{
            signal:controller.signal
          })
          isMounted &&  setData(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed])
  const CustomTableViewCol = (props) => {
    return <TableViewCol {...props} sx={{padding:'16px 24px 16px 24px',}} />;
};
  const {state}=useContext(ProfileContext);
  const {calendar}=state
  const {year, semester}=calendar
  
  const columns = [
 {
  name: "c_name",
  label: "Course Name",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "c_code",
  label: "Course Code",
  options: {
   filter: true,
   sort: true,
   display:false,
  }
 },
  {
  name: "batch",
  label: "Batch",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "section",
  label: "Section",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "group_t",
  label: "Group Type",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "n_students",
  label: "Number of Students",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "load",
  label: "LEH",
  options: {
   filter: true,
   sort: true,
  }
},
{
name: "a_year",
label: "Academic Year",
options: {
filter: true,
sort: true,
filterList: [year],

}
},
   {
  name: "semester",
  label: "Semester Term",
  options: {
   filter: true,
   sort: true,
   filterList: [semester],
  }
 },
  {
  name: "admission",
  label: "Admission Type",
  options: {
   filter: true,
   sort: true,
  }
 },
]
 return(
  		<CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={"Teaching Groups"}
  data={data}
  columns={columns}
  options={options}
/></CacheProvider>
 ) 
}
